module.exports = __webpack_public_path__ + "img/usa-external-causes-female.072bd326.png";